/* Furniture Instore — PDP v5, modular sofas (snippets/fi-modular-part.liquid).

   A modular sofa is never bought as itself. The customer buys either a ready-made set
   (one layout product) or a build (several module products), with an optional footstool,
   and those are the lines that go into the basket. This file owns the choice and
   everything that has to follow it: the price block, the finance figures, the summary,
   the button prices and the single /cart/add.js call.

   fi-pdp-v5.js asks window.FIModular for the price, the availability and the lines
   wherever it would otherwise read the sofa's own variant, so the sticky bar, Buy Now,
   the add-on prompt and the finance popup all quote the same figure as this file. */
(function () {
  'use strict';

  if (window.FIModular && window.FIModular.booted) return;
  var api = (window.FIModular = { booted: true });

  var HISTORY_LIMIT = 40;

  var state = {
    mode: 'set',
    layoutId: null,
    /* The build as a chain, in order along the backs: [{ uid, pid }]. Footstools stand
       apart from the chain and are kept separately. */
    plan: [],
    stools: [],
    flipped: false,
    selected: null,
    history: [],
    nextUid: 1,
    /* Whether the build has been given its starting plan yet: once, on first opening. */
    seeded: false,
    /* The sofa's selected option values, lower-cased — what each sub-product's variant is
       matched against. */
    options: []
  };

  /* Module products by product id, read from the rows. */
  var catalog = {};

  function $(selector, root) {
    return (root || document).querySelector(selector);
  }

  function $$(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function newToken() {
    return Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
  }

  /* The shop's own format, with the thousands separators Liquid's money filter puts in,
     so a figure written here reads the same as the one Liquid wrote beside it. */
  function money(cents) {
    var fmt = ((window.FIPDP && window.FIPDP.moneyFormat) || '£{{amount}}').replace(/<[^>]*>/g, '');
    var token = /\{\{\s*(\w+)\s*\}\}/.exec(fmt);
    var kind = token ? token[1] : 'amount';
    var group = function (decimals, thousands, decimal) {
      var parts = (cents / 100).toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.length > 1 ? parts[0] + decimal + parts[1] : parts[0];
    };
    var value;
    switch (kind) {
      case 'amount_no_decimals':
        value = group(0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        value = group(2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = group(0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = group(2, "'", '.');
        break;
      default:
        value = group(2, ',', '.');
    }
    return token ? fmt.replace(token[0], value) : value;
  }

  function fill(template, count) {
    return String(template || '').split('[count]').join(String(count));
  }

  /* ---- Reading the page ---- */

  function cards() {
    return $$('[data-fi-mod-layout]');
  }

  function rows() {
    return $$('[data-fi-mod-module]');
  }

  function stoolBox() {
    return $('[data-fi-mod-footstool]');
  }

  function builder() {
    return $('[data-fi-mod-builder]');
  }

  function mainForm() {
    return $('product-info form[data-type="add-to-cart-form"]');
  }

  function quantity() {
    if (window.FIPDP && typeof window.FIPDP.currentQuantity === 'function') return window.FIPDP.currentQuantity();
    var input = $('.fi-actions [name="quantity"]') || $('product-info [name="quantity"]');
    var qty = input ? parseInt(input.value, 10) : 1;
    return isNaN(qty) || qty < 1 ? 1 : qty;
  }

  function addonExtra() {
    if (window.FIPDP && typeof window.FIPDP.addonExtra === 'function') return window.FIPDP.addonExtra();
    return 0;
  }

  function parseVariants(el) {
    try {
      return JSON.parse(el.getAttribute('data-variants') || '[]');
    } catch (e) {
      return [];
    }
  }

  /* Same choice as snippets/fi-modular-variant.liquid: two points per matching option
     value, one for being in stock, first wins a tie. */
  function pickVariant(el) {
    var variants = parseVariants(el);
    if (!variants.length) {
      var id = Number(el.getAttribute('data-variant-id'));
      return id ? { id: id, p: parseInt(el.getAttribute('data-price'), 10) || 0, c: 0, a: true, s: '' } : null;
    }
    if (variants.length === 1) return variants[0];
    var best = null;
    var bestScore = -1;
    variants.forEach(function (variant) {
      var score = 0;
      (variant.o || []).forEach(function (value) {
        if (state.options.indexOf(value) !== -1) score += 2;
      });
      if (variant.a) score += 1;
      if (score > bestScore) {
        bestScore = score;
        best = variant;
      }
    });
    return best;
  }

  function readOptions(variant) {
    if (!variant) {
      var node = $('product-info variant-selects [data-selected-variant]');
      try {
        variant = node ? JSON.parse(node.textContent) : null;
      } catch (e) {
        variant = null;
      }
    }
    state.options = variant && variant.options
      ? variant.options.map(function (value) {
          return String(value).toLowerCase();
        })
      : [];
  }

  /* "W 85 × D 90 × H 83 cm" → 85 × 90. A bare "345 × 175 cm" is read as width × depth.
     Without a reading the piece is drawn square, and the plan quotes no overall size. */
  function footprint(text) {
    var t = String(text || '');
    var w = /\bW\s*([\d.]+)/i.exec(t);
    var d = /\bD\s*([\d.]+)/i.exec(t);
    if (w && d) return { w: parseFloat(w[1]), d: parseFloat(d[1]), known: true };
    var numbers = t.match(/\d+(?:\.\d+)?/g);
    if (numbers && numbers.length >= 2) return { w: parseFloat(numbers[0]), d: parseFloat(numbers[1]), known: true };
    return { w: 90, d: 90, known: false };
  }

  /* custom.module_type, forgiving of case and of "arm-left" / "Arm Left". */
  function kindOf(type) {
    var t = String(type || '').toLowerCase().replace(/[\s-]+/g, '_');
    if (t === 'arm_left' || t === 'left_arm') return 'armL';
    if (t === 'arm_right' || t === 'right_arm') return 'armR';
    if (t === 'corner') return 'corner';
    if (t === 'footstool' || t === 'footstall' || t === 'ottoman') return 'stool';
    return 'seat';
  }

  function readCatalog() {
    catalog = {};
    rows().forEach(function (row) {
      var pid = row.getAttribute('data-product-id');
      catalog[pid] = {
        pid: pid,
        row: row,
        kind: kindOf(row.getAttribute('data-type')),
        max: parseInt(row.getAttribute('data-max'), 10) || 6,
        title: row.getAttribute('data-title') || '',
        size: footprint(row.getAttribute('data-dimensions')),
        variant: null
      };
    });
    var linked = linkedStool();
    if (linked) catalog[linked].kind = 'stool';
  }

  /* The footstool row's product, when it is also one of the modules. Then the tickbox and
     that module's stepper are the same choice. */
  function linkedStool() {
    var box = stoolBox();
    var pid = box && box.getAttribute('data-product-id');
    return pid && catalog[pid] ? pid : null;
  }

  /* ---- Variants follow the sofa's colour ---- */

  function paintSoldOut(el, available) {
    el.classList.toggle('is-unavailable', !available);
    var flag = $('[data-fi-mod-soldout]', el);
    if (flag) flag.hidden = available;
  }

  function resolveVariants() {
    cards().forEach(function (card) {
      var variant = pickVariant(card);
      card.fiVariant = variant;
      if (!variant) return;
      card.setAttribute('data-variant-id', variant.id);
      card.setAttribute('data-price', variant.p);
      var price = $('[data-fi-mod-price]', card);
      if (price) price.textContent = money(variant.p);
      var sku = $('[data-fi-mod-sku]', card);
      if (sku) sku.textContent = variant.s || '';
      var dot = $('[data-fi-mod-sku-dot]', card);
      if (dot) dot.hidden = !variant.s;
      paintSoldOut(card, variant.a);
    });

    Object.keys(catalog).forEach(function (pid) {
      var item = catalog[pid];
      item.variant = pickVariant(item.row);
      if (!item.variant) return;
      item.row.setAttribute('data-variant-id', item.variant.id);
      item.row.setAttribute('data-price', item.variant.p);
      var price = $('[data-fi-mod-price]', item.row);
      if (price) price.textContent = money(item.variant.p);
      paintSoldOut(item.row, item.variant.a);
    });

    var box = stoolBox();
    if (box) {
      var variant = pickVariant(box);
      box.fiVariant = variant;
      if (variant) {
        box.setAttribute('data-variant-id', variant.id);
        box.setAttribute('data-price', variant.p);
        var row = box.closest('.fi-modular-footstool');
        var price = row && $('[data-fi-mod-price]', row);
        if (price) price.textContent = (price.getAttribute('data-prefix') || '') + money(variant.p);
        if (row) row.classList.toggle('is-unavailable', !variant.a);
        box.disabled = !variant.a;
        /* A footstool not made in the new colour cannot stay ticked. */
        if (!variant.a && box.checked) {
          box.checked = false;
          if (linkedStool()) removeAll(linkedStool(), true);
        }
      }
    }
  }

  /* ---- What is being bought ---- */

  function activeCard() {
    var list = cards();
    for (var i = 0; i < list.length; i += 1) {
      if (list[i].getAttribute('data-product-id') === state.layoutId) return list[i];
    }
    return list[0] || null;
  }

  function stoolTicked() {
    var box = stoolBox();
    return !!(box && box.checked && !box.disabled && box.fiVariant);
  }

  /* The ticked footstool goes in as its own line, unless it is a module of the build, in
     which case it is already one of the pieces. */
  function stoolLineNeeded() {
    return stoolTicked() && (state.mode === 'set' || !linkedStool());
  }

  function pieces() {
    return state.plan.concat(state.stools);
  }

  function count(pid) {
    return pieces().filter(function (piece) {
      return piece.pid === pid;
    }).length;
  }

  /* Every variant the current choice puts in the basket, once per piece. */
  function chosenVariants() {
    var list = [];
    if (state.mode === 'set') {
      var card = activeCard();
      if (card && card.fiVariant) list.push(card.fiVariant);
    } else {
      pieces().forEach(function (piece) {
        var item = catalog[piece.pid];
        if (item && item.variant) list.push(item.variant);
      });
    }
    if (stoolLineNeeded()) list.push(stoolBox().fiVariant);
    return list;
  }

  function unitPrice() {
    return chosenVariants().reduce(function (sum, variant) {
      return sum + variant.p;
    }, 0);
  }

  /* The struck-through figure only when something in the choice really is reduced;
     otherwise 0, and no saving is shown. */
  function unitCompare() {
    var list = chosenVariants();
    var reduced = list.some(function (variant) {
      return variant.c > variant.p;
    });
    if (!reduced) return 0;
    return list.reduce(function (sum, variant) {
      return sum + Math.max(variant.c, variant.p);
    }, 0);
  }

  /* The cheapest sofa piece in stock, for "From" while the build is still empty. Not the
     footstool: a sofa does not start at the price of one. */
  function cheapestModule() {
    var low = 0;
    Object.keys(catalog).forEach(function (pid) {
      var variant = catalog[pid].variant;
      if (catalog[pid].kind === 'stool') return;
      if (variant && variant.a && (!low || variant.p < low)) low = variant.p;
    });
    return low;
  }

  function ready() {
    if (state.mode === 'set') {
      var card = activeCard();
      if (!card || !card.fiVariant || !card.fiVariant.a) return false;
    } else {
      if (!pieces().length) return false;
      var missing = pieces().some(function (piece) {
        var item = catalog[piece.pid];
        return !item || !item.variant || !item.variant.a;
      });
      if (missing) return false;
    }
    return !stoolTicked() || stoolBox().fiVariant.a;
  }

  /* "Arm unit · left – Armless seat – Corner section – Arm unit · right (+ Footstool)",
     in order from the left as drawn, for the build's basket line. */
  function describeBuild() {
    var chain = state.plan.map(function (piece) {
      return catalog[piece.pid] ? catalog[piece.pid].title : '';
    });
    if (state.flipped) chain.reverse();
    var text = chain.join(' – ');
    state.stools.forEach(function (piece) {
      text += ' (+ ' + catalog[piece.pid].title + ')';
    });
    return text;
  }

  /* The basket lines. Each add gets its own group token, so the same build added twice
     stays two builds. _fi_modular_units says how many sofas a line stands for, so the
     basket counts a six-piece build as one sofa, not six, when it sets the delivery
     quantity (fi-cart-line-flags.liquid, fi-care-plan-tier.js). A set's layout line
     needs none: it is the sofa, and its own quantity already counts it — and stays
     right if the customer changes it in the drawer. */
  function lines(qty) {
    qty = qty || quantity();
    var group = newToken();
    var out = [];
    var lead = function (extra) {
      var properties = { _fi_modular: group, _fi_modular_units: String(qty) };
      if (extra) {
        Object.keys(extra).forEach(function (key) {
          properties[key] = extra[key];
        });
      }
      return properties;
    };
    var follower = { _fi_modular: group, _fi_modular_units: '0' };

    if (state.mode === 'set') {
      var card = activeCard();
      if (card && card.fiVariant) out.push({ id: card.fiVariant.id, quantity: qty, properties: { _fi_modular: group } });
    } else {
      var counts = {};
      var order = [];
      pieces().forEach(function (piece) {
        var variant = catalog[piece.pid] && catalog[piece.pid].variant;
        if (!variant) return;
        if (!counts[variant.id]) {
          counts[variant.id] = 0;
          order.push(variant.id);
        }
        counts[variant.id] += 1;
      });
      var summary = $('[data-fi-mod-summary]');
      var planLabel = (summary && summary.getAttribute('data-build-label')) || 'Layout';
      order.forEach(function (id, index) {
        var extra = {};
        extra[planLabel] = describeBuild();
        out.push({ id: id, quantity: counts[id] * qty, properties: index === 0 ? lead(extra) : follower });
      });
    }

    if (stoolLineNeeded()) {
      out.push({ id: stoolBox().fiVariant.id, quantity: qty, properties: out.length ? follower : lead() });
    }
    return out;
  }

  /* ---- Mode ---- */

  function modesOnOffer() {
    return { set: cards().length > 0, build: !!builder() && Object.keys(catalog).length > 0 };
  }

  function setMode(mode) {
    var offer = modesOnOffer();
    if (mode === 'set' && !offer.set) mode = 'build';
    if (mode === 'build' && !offer.build) mode = 'set';
    state.mode = mode;
    state.selected = null;

    $$('[data-fi-mod-mode]').forEach(function (tab) {
      var on = tab.getAttribute('data-fi-mod-mode') === mode;
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
      tab.tabIndex = on ? 0 : -1;
    });
    $$('[data-fi-mod-panel]').forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-fi-mod-panel') !== mode;
    });

    /* Entering the build, the tickbox decides: a footstool ticked on the set view
       becomes a piece of the build, and one unticked there leaves it. */
    if (mode === 'build') {
      if (!state.seeded) {
        state.seeded = true;
        seedPlan();
      }
      var linked = linkedStool();
      if (linked) {
        if (stoolTicked() && !count(linked)) addPiece(linked, true);
        if (!stoolTicked() && count(linked)) removeAll(linked, true);
      }
    }
    schedule();
  }

  /* The plan the build opens on — the block's "Starting plan", a list of module types in
     order along the backs — so the shopper edits a sofa rather than starting from nothing.
     Each type takes the first module of that type; one sold out or at its limit is left
     out. A footstool that is the tickbox's product ticks it, as adding one by hand does. */
  function seedPlan() {
    var host = builder();
    var start = host && host.getAttribute('data-start');
    if (!start || pieces().length) return;
    start.split(',').forEach(function (token) {
      if (!token.trim()) return;
      var kind = kindOf(token.trim());
      var pid = null;
      Object.keys(catalog).forEach(function (id) {
        if (!pid && catalog[id].kind === kind && canAdd(id)) pid = id;
      });
      if (!pid) return;
      var piece = { uid: state.nextUid, pid: pid };
      state.nextUid += 1;
      if (kind === 'stool') {
        state.stools.push(piece);
      } else {
        state.plan.push(piece);
      }
    });
    var linked = linkedStool();
    var box = stoolBox();
    if (linked && box && count(linked)) box.checked = true;
  }

  /* ---- Building ---- */

  function startArm() {
    return state.flipped ? 'armR' : 'armL';
  }

  function endArm() {
    return state.flipped ? 'armL' : 'armR';
  }

  function kindAt(index) {
    var piece = state.plan[index];
    return piece && catalog[piece.pid] ? catalog[piece.pid].kind : null;
  }

  /* Where a new piece of this kind goes in the chain. Arms close the ends, a corner turns
     the run before the closing arm, and a seat joins the run with fewest seats (the
     earliest on a tie), so tapping + keeps the shape balanced. */
  function insertIndex(kind) {
    var n = state.plan.length;
    if (kind === startArm()) return 0;
    if (kind === endArm()) return n;
    var tail = n && kindAt(n - 1) === endArm() ? n - 1 : n;
    if (kind === 'corner') return tail;

    var head = n && kindAt(0) === startArm() ? 1 : 0;
    var runs = [];
    var seats = 0;
    for (var i = head; i < tail; i += 1) {
      if (kindAt(i) === 'corner') {
        runs.push({ end: i, seats: seats });
        seats = 0;
      } else {
        seats += 1;
      }
    }
    runs.push({ end: tail, seats: seats });
    var best = runs[0];
    runs.forEach(function (run) {
      if (run.seats < best.seats) best = run;
    });
    return best.end;
  }

  function canAdd(pid) {
    var item = catalog[pid];
    return !!(item && item.variant && item.variant.a && count(pid) < item.max);
  }

  function remember() {
    state.history.push(JSON.stringify({ plan: state.plan, stools: state.stools, flipped: state.flipped }));
    if (state.history.length > HISTORY_LIMIT) state.history.shift();
  }

  function addPiece(pid, quiet) {
    if (!canAdd(pid)) return false;
    if (!quiet) remember();
    var piece = { uid: state.nextUid, pid: pid };
    state.nextUid += 1;
    if (catalog[pid].kind === 'stool') {
      state.stools.push(piece);
    } else {
      state.plan.splice(insertIndex(catalog[pid].kind), 0, piece);
    }
    /* The piece just added is shown picked, so the shopper sees where it went. */
    state.selected = quiet ? null : piece.uid;
    planChanged();
    return true;
  }

  function dropPiece(uid) {
    state.plan = state.plan.filter(function (piece) {
      return piece.uid !== uid;
    });
    state.stools = state.stools.filter(function (piece) {
      return piece.uid !== uid;
    });
  }

  /* − takes away the most recently added piece of that product. */
  function removeOne(pid) {
    var last = null;
    pieces().forEach(function (piece) {
      if (piece.pid === pid && (!last || piece.uid > last.uid)) last = piece;
    });
    if (!last) return;
    remember();
    dropPiece(last.uid);
    if (state.selected === last.uid) state.selected = null;
    planChanged();
  }

  function removeAll(pid, quiet) {
    if (!count(pid)) return;
    if (!quiet) remember();
    state.plan = state.plan.filter(function (piece) {
      return piece.pid !== pid;
    });
    state.stools = state.stools.filter(function (piece) {
      return piece.pid !== pid;
    });
    planChanged();
  }

  function removeSelected() {
    if (state.selected === null) return;
    remember();
    dropPiece(state.selected);
    state.selected = null;
    planChanged();
  }

  /* Only a footstool turns: a seat, an arm or a corner turned on the spot no longer
     joins its neighbours, and which hand the corner is on is what Flip is for. */
  function rotateSelected() {
    var stool = state.stools.filter(function (piece) {
      return piece.uid === state.selected;
    })[0];
    if (!stool) return;
    remember();
    stool.turned = !stool.turned;
    planChanged();
  }

  /* The mirror image. An arm unit is handed, so a left arm drawn at the right-hand end
     would be the wrong product: each arm is swapped for the module of the other hand,
     when the range has one, so the basket matches the drawing. */
  function otherHand(kind) {
    var want = kind === 'armL' ? 'armR' : 'armL';
    var found = null;
    Object.keys(catalog).forEach(function (pid) {
      if (!found && catalog[pid].kind === want) found = pid;
    });
    return found;
  }

  function flip() {
    if (!state.plan.length) return;
    remember();
    var toRight = otherHand('armL');
    var toLeft = otherHand('armR');
    state.plan = state.plan.map(function (piece) {
      var kind = catalog[piece.pid].kind;
      if (kind === 'armL' && toRight) return { uid: piece.uid, pid: toRight };
      if (kind === 'armR' && toLeft) return { uid: piece.uid, pid: toLeft };
      return piece;
    });
    state.flipped = !state.flipped;
    state.selected = null;
    planChanged();
  }

  function clearPlan() {
    if (!pieces().length) return;
    remember();
    state.plan = [];
    state.stools = [];
    state.flipped = false;
    state.selected = null;
    planChanged();
  }

  function undo() {
    var last = state.history.pop();
    if (!last) return;
    var saved = JSON.parse(last);
    state.plan = saved.plan;
    state.stools = saved.stools;
    state.flipped = saved.flipped;
    state.selected = null;
    planChanged();
  }

  function planChanged() {
    var linked = linkedStool();
    var box = stoolBox();
    if (linked && box && state.mode === 'build') box.checked = count(linked) > 0;
    schedule();
  }

  /* Arms only at the ends and no more than two corners. Anything else is still allowed
     into the basket — spare pieces are a real order — but the plan says so. */
  function checkPlan() {
    var n = state.plan.length;
    var corners = 0;
    var fits = n > 0;
    state.plan.forEach(function (piece, index) {
      var kind = catalog[piece.pid] ? catalog[piece.pid].kind : 'seat';
      if (kind === 'corner') corners += 1;
      if (kind === startArm() && index !== 0) fits = false;
      if (kind === endArm() && index !== n - 1) fits = false;
    });
    if (corners > 2) fits = false;
    return { fits: fits, seats: n };
  }

  /* ---- Geometry ----
     The chain is walked along the backs. Each piece covers its width along the run and
     its depth inwards from the back line; a corner turns the run clockwise, so the backs
     stay on the outside. All in centimetres; drawn to scale afterwards. */
  function side(vx, vy) {
    if (vy < 0) return 'top';
    if (vx > 0) return 'right';
    if (vy > 0) return 'bottom';
    return 'left';
  }

  function geometry() {
    var x = 0;
    var y = 0;
    var dx = 1;
    var dy = 0;
    var n = state.plan.length;
    var shapes = [];
    var firstDepth = 0;
    var firstCorner = null;
    var corners = 0;

    state.plan.forEach(function (piece, index) {
      var item = catalog[piece.pid];
      var kind = item.kind;
      var len = item.size.w;
      var dep = item.size.d;
      var nx = dy;
      var ny = -dx;
      var x2 = x + dx * len - nx * dep;
      var y2 = y + dy * len - ny * dep;
      var edges = [side(nx, ny)];
      if (index === 0 && kind === startArm()) edges.push(side(-dx, -dy));
      if (index === n - 1 && kind === endArm()) edges.push(side(dx, dy));
      if (kind === 'corner') edges.push(side(dx, dy));
      if (index === 0) firstDepth = dep;

      var shape = {
        uid: piece.uid,
        pid: piece.pid,
        kind: kind,
        x: Math.min(x, x2),
        y: Math.min(y, y2),
        w: Math.abs(x2 - x),
        h: Math.abs(y2 - y),
        edges: edges
      };
      shapes.push(shape);

      if (kind === 'corner' && corners < 2) {
        corners += 1;
        if (!firstCorner) firstCorner = { shape: shape, depth: dep };
        x += dx * len;
        y += dy * len;
        var ndx = -dy;
        dy = dx;
        dx = ndx;
        x += dx * dep;
        y += dy * dep;
      } else {
        x += dx * len;
        y += dy * len;
      }
    });

    var box = bounds(shapes);

    /* Footstools sit in the well of an L or U, or in front of a straight sofa. */
    if (state.stools.length) {
      var gap = 20;
      var sizes = state.stools.map(function (piece) {
        var size = catalog[piece.pid].size;
        return piece.turned ? { w: size.d, h: size.w } : { w: size.w, h: size.d };
      });
      var rowWidth = sizes.reduce(function (sum, size) {
        return sum + size.w;
      }, 0) + gap * (sizes.length - 1);
      var rowHeight = Math.max.apply(null, sizes.map(function (size) {
        return size.h;
      }));

      var well = null;
      if (firstCorner && shapes.length) {
        well = {
          left: box.x,
          right: firstCorner.shape.x + firstCorner.shape.w - firstCorner.depth,
          top: box.y + firstDepth,
          bottom: corners >= 2 ? box.y + box.h - firstDepth : box.y + box.h
        };
        if (well.right - well.left < rowWidth + gap * 2 || well.bottom - well.top < rowHeight + gap * 2) well = null;
      }
      if (!well) {
        var top = shapes.length ? box.y + box.h + gap * 1.5 : 0;
        var left = shapes.length ? box.x : 0;
        var right = shapes.length ? box.x + box.w : rowWidth;
        well = { left: left, right: Math.max(right, left + rowWidth), top: top, bottom: top + rowHeight };
      }

      var sx = (well.left + well.right - rowWidth) / 2;
      var sy = (well.top + well.bottom - rowHeight) / 2;
      state.stools.forEach(function (piece, i) {
        shapes.push({
          uid: piece.uid,
          pid: piece.pid,
          kind: 'stool',
          x: sx,
          y: sy + (rowHeight - sizes[i].h) / 2,
          w: sizes[i].w,
          h: sizes[i].h,
          edges: []
        });
        sx += sizes[i].w + gap;
      });
    }

    var all = bounds(shapes);
    var mirror = { left: 'right', right: 'left', top: 'top', bottom: 'bottom' };
    shapes.forEach(function (shape) {
      shape.x -= all.x;
      shape.y -= all.y;
      if (state.flipped) {
        shape.x = all.w - shape.x - shape.w;
        shape.edges = shape.edges.map(function (edge) {
          return mirror[edge];
        });
      }
    });

    var sofa = bounds(shapes.filter(function (shape) {
      return shape.kind !== 'stool';
    }));
    var measured = state.plan.every(function (piece) {
      return catalog[piece.pid].size.known;
    });
    return { shapes: shapes, w: all.w, h: all.h, sofa: sofa, measured: measured && state.plan.length > 0 };
  }

  function bounds(shapes) {
    if (!shapes.length) return { x: 0, y: 0, w: 0, h: 0 };
    var minX = Infinity;
    var minY = Infinity;
    var maxX = -Infinity;
    var maxY = -Infinity;
    shapes.forEach(function (shape) {
      minX = Math.min(minX, shape.x);
      minY = Math.min(minY, shape.y);
      maxX = Math.max(maxX, shape.x + shape.w);
      maxY = Math.max(maxY, shape.y + shape.h);
    });
    return { x: minX, y: minY, w: maxX - minX, h: maxY - minY };
  }

  /* ---- Drawing ---- */

  function label(kind, item) {
    var host = builder();
    var key = { armL: 'arm', armR: 'arm', seat: 'seat', corner: 'corner', stool: 'footstool' }[kind];
    var text = host && host.getAttribute('data-label-' + key);
    return text || (item ? item.title : '');
  }

  function cm(value) {
    return Math.round(value) + ' cm';
  }

  function drawPlan() {
    var host = builder();
    if (!host) return;
    var stage = $('[data-fi-mod-stage]', host);
    var empty = $('[data-fi-mod-empty]', host);
    var pop = $('[data-fi-mod-pop]', host);
    if (!stage) return;

    var geo = geometry();
    var shapes = geo.shapes;
    stage.textContent = '';
    if (empty) empty.hidden = shapes.length > 0;

    if (shapes.length) {
      /* The stage keeps its aspect ratio in CSS, so positions are written as percentages
         of it and stay right however wide the column is drawn. Units are a 1000-wide
         stage; the margins leave room for the dimension lines on the top and right. */
      var ratio = stage.clientWidth && stage.clientHeight ? stage.clientWidth / stage.clientHeight : 4 / 3;
      var W = 1000;
      var H = W / ratio;
      var padX = 70;
      var padTop = 110;
      var padRight = 130;
      var padBottom = 60;
      var spanW = Math.max(geo.w, 300);
      var spanH = Math.max(geo.h, 200);
      var scale = Math.min((W - padX - padRight) / spanW, (H - padTop - padBottom) / spanH);
      var offX = padX + (W - padX - padRight - geo.w * scale) / 2;
      var offY = padTop + (H - padTop - padBottom - geo.h * scale) / 2;
      var pct = function (value, of) {
        return (value / of) * 100 + '%';
      };
      var place = function (el, x, y, w, h) {
        el.style.left = pct(offX + x * scale, W);
        el.style.top = pct(offY + y * scale, H);
        el.style.width = pct(w * scale, W);
        el.style.height = pct(h * scale, H);
      };

      var total = state.plan.length;
      shapes.forEach(function (shape) {
        var item = catalog[shape.pid];
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'fi-modular-piece fi-modular-piece--' + shape.kind;
        shape.edges.forEach(function (edge) {
          button.classList.add('has-' + edge);
        });
        button.setAttribute('data-fi-mod-piece', shape.uid);
        button.setAttribute('aria-pressed', state.selected === shape.uid ? 'true' : 'false');
        var position = state.plan.map(function (piece) {
          return piece.uid;
        }).indexOf(shape.uid);
        button.setAttribute(
          'aria-label',
          item.title + (position >= 0 ? ' (' + (position + 1) + '/' + total + ')' : '')
        );
        var text = document.createElement('span');
        text.className = 'fi-modular-piece__label';
        text.textContent = label(shape.kind, item);
        button.appendChild(text);
        place(button, shape.x, shape.y, shape.w, shape.h);
        stage.appendChild(button);
      });

      if (geo.measured) {
        var across = document.createElement('div');
        across.className = 'fi-modular-dim fi-modular-dim--x';
        across.setAttribute('aria-hidden', 'true');
        across.innerHTML = '<span class="fi-modular-dim__text"></span>';
        across.firstChild.textContent = cm(geo.sofa.w);
        across.style.left = pct(offX + geo.sofa.x * scale, W);
        across.style.width = pct(geo.sofa.w * scale, W);
        across.style.top = pct(offY - 55, H);
        stage.appendChild(across);

        var down = document.createElement('div');
        down.className = 'fi-modular-dim fi-modular-dim--y';
        down.setAttribute('aria-hidden', 'true');
        down.innerHTML = '<span class="fi-modular-dim__text"></span>';
        down.firstChild.textContent = cm(geo.sofa.h);
        down.style.top = pct(offY + geo.sofa.y * scale, H);
        down.style.height = pct(geo.sofa.h * scale, H);
        down.style.left = pct(offX + (geo.sofa.x + geo.sofa.w) * scale + 40, W);
        stage.appendChild(down);
      }

      /* The selected piece's actions sit just under it. */
      var picked = shapes.filter(function (shape) {
        return shape.uid === state.selected;
      })[0];
      if (pop) {
        pop.hidden = !picked;
        if (picked) {
          var below = offY + (picked.y + picked.h) * scale + 14;
          pop.style.left = pct(Math.min(Math.max(offX + (picked.x + picked.w / 2) * scale, 120), W - 120), W);
          pop.style.top = pct(Math.min(below, H - 70), H);
          var rotate = $('[data-fi-mod-rotate]', pop);
          if (rotate) rotate.hidden = picked.kind !== 'stool';
        }
      }
    } else if (pop) {
      pop.hidden = true;
    }

    /* The overall size, said once for screen readers alongside the status. */
    host.fiGeometry = geo;
  }

  function paintBuilder() {
    var host = builder();
    if (!host) return;

    Object.keys(catalog).forEach(function (pid) {
      var item = catalog[pid];
      var qty = count(pid);
      var out = $('[data-fi-mod-qty]', item.row);
      if (out && out.textContent !== String(qty)) out.textContent = String(qty);
      item.row.classList.toggle('is-picked', qty > 0);
      var minus = $('[data-fi-mod-step="-1"]', item.row);
      var plus = $('[data-fi-mod-step="1"]', item.row);
      if (minus) minus.disabled = qty === 0;
      if (plus) {
        plus.disabled = !canAdd(pid);
        var full = qty >= item.max;
        if (full && host.getAttribute('data-max-txt')) {
          plus.title = fill(host.getAttribute('data-max-txt'), item.max);
        } else {
          plus.removeAttribute('title');
        }
      }
    });

    var meta = $('[data-fi-mod-count]', host);
    if (meta) {
      var text = fill(host.getAttribute('data-count-tpl'), state.plan.length);
      if (state.stools.length && host.getAttribute('data-footstool-tpl')) text += ' ' + host.getAttribute('data-footstool-tpl');
      meta.textContent = text;
    }

    var status = $('[data-fi-mod-status]', host);
    var statusText = $('[data-fi-mod-status-text]', host);
    if (status && statusText) {
      var plan = checkPlan();
      status.hidden = !pieces().length;
      status.classList.toggle('is-warning', !plan.fits || !ready());
      statusText.textContent = plan.fits && ready()
        ? [host.getAttribute('data-works'), fill(host.getAttribute('data-seats'), plan.seats)].filter(Boolean).join(' · ')
        : host.getAttribute('data-warn') || '';
    }

    var tools = {
      undo: state.history.length > 0,
      flip: state.plan.length > 0,
      clear: pieces().length > 0
    };
    Object.keys(tools).forEach(function (name) {
      var button = $('[data-fi-mod-' + name + ']', host);
      if (button) button.disabled = !tools[name];
    });

    drawPlan();
  }

  function paintCards() {
    var current = activeCard();
    cards().forEach(function (card) {
      var on = card === current;
      card.classList.toggle('is-active', on);
      var button = $('[data-fi-mod-select]', card);
      if (button) button.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  /* ---- The rest of the buy column ---- */

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined && text !== null) node.textContent = text;
    return node;
  }

  /* Children with a space between each, as Liquid writes them. The containers are flex,
     where a space draws nothing, but the text read out (the price block is a live
     region) no longer runs "£1,945.00Was £2,469.00" together. */
  function append(parent, nodes) {
    nodes.forEach(function (node, index) {
      if (index) parent.appendChild(document.createTextNode(' '));
      parent.appendChild(node);
    });
    return parent;
  }

  function summaryLine(list, name, amount, muted) {
    var li = el('li', 'fi-modular-summary__line' + (muted ? ' fi-modular-summary__line--muted' : ''));
    append(li, [el('span', 'fi-modular-summary__name', name), el('span', 'fi-modular-summary__amount', amount)]);
    list.appendChild(li);
  }

  function paintSummary() {
    var box = $('[data-fi-mod-summary]');
    var body = box && $('[data-fi-mod-summary-body]', box);
    if (!body) return;
    var d = box.dataset;
    var qty = quantity();
    var extras = addonExtra();
    var stool = stoolBox();

    var signature = JSON.stringify([state.mode, state.layoutId, pieces(), state.flipped, unitPrice(), qty, extras, stoolTicked(), stool && stool.fiVariant && stool.fiVariant.id]);
    if (box.fiSignature === signature) return;
    box.fiSignature = signature;

    var frag = document.createDocumentFragment();
    var head = el('div', 'fi-modular-summary__head');
    var list = el('ul', 'fi-modular-summary__lines');
    list.setAttribute('role', 'list');

    if (state.mode === 'set') {
      var card = activeCard();
      var variant = card && card.fiVariant;
      var setHead = [el('h3', 'fi-modular-summary__title', d.setLabel)];
      if (card && card.hasAttribute('data-default') && d.asPictured) setHead.push(el('span', 'fi-modular-badge', d.asPictured));
      frag.appendChild(append(head, setHead));
      if (card && variant) {
        summaryLine(list, card.getAttribute('data-title'), money(variant.p));
        var dims = card.getAttribute('data-dimensions');
        var note = [variant.s, dims ? (d.approx ? d.approx + ' ' : '') + dims : ''].filter(Boolean).join(' · ');
        if (note) list.appendChild(el('li', 'fi-modular-summary__note', note));
      }
    } else {
      var buildHead = [el('h3', 'fi-modular-summary__title', d.buildLabel)];
      if (d.editLabel && builder()) {
        var edit = el('button', 'fi-modular-summary__edit', d.editLabel);
        edit.type = 'button';
        edit.setAttribute('data-fi-mod-edit', '');
        buildHead.push(edit);
      }
      frag.appendChild(append(head, buildHead));

      if (!pieces().length) {
        frag.appendChild(el('p', 'fi-modular-summary__empty', d.empty));
      } else {
        var counts = {};
        var order = [];
        pieces().forEach(function (piece) {
          if (!counts[piece.pid]) {
            counts[piece.pid] = 0;
            order.push(piece.pid);
          }
          counts[piece.pid] += 1;
        });
        order.forEach(function (pid) {
          var item = catalog[pid];
          var each = item.variant ? item.variant.p : 0;
          summaryLine(list, item.title + ' × ' + counts[pid], money(each * counts[pid]));
        });
        var geo = builder() && builder().fiGeometry;
        if (geo && geo.measured && d.sizeLabel) {
          list.appendChild(el('li', 'fi-modular-summary__note', d.sizeLabel + ' ' + Math.round(geo.sofa.w) + ' × ' + Math.round(geo.sofa.h) + ' cm'));
        }
      }
    }

    /* The footstool row, when it is its own line rather than a piece of the build. */
    if (stool && stool.fiVariant && (state.mode === 'set' || !linkedStool()) && d.footstoolLabel) {
      summaryLine(
        list,
        d.footstoolLabel,
        stoolTicked() ? '+' + money(stool.fiVariant.p) : d.notAdded,
        !stoolTicked()
      );
    }
    if (extras > 0 && d.addonsLabel) summaryLine(list, d.addonsLabel, '+' + money(extras));
    if (list.childNodes.length) frag.appendChild(list);

    if (state.mode === 'set' || pieces().length) {
      frag.appendChild(
        append(el('p', 'fi-modular-summary__total'), [
          el('span', null, d.totalLabel + (qty > 1 ? ' (× ' + qty + ')' : '')),
          el('strong', null, money(unitPrice() * qty + extras))
        ])
      );
    }

    body.textContent = '';
    body.appendChild(frag);
  }

  /* product-info.js rewrites this block from the sofa's own variant on every colour
     change, so it is put back from here each time — see restore(). */
  function paintPrice() {
    var box = $('product-info .fi-price');
    if (!box) return;
    var empty = state.mode === 'build' && !pieces().length;
    var now = empty ? cheapestModule() : unitPrice();
    var was = empty ? 0 : unitCompare();
    var signature = [now, was, empty].join('|');
    if (box.fiSignature === signature && $('[data-fi-mod]', box)) return;
    box.fiSignature = signature;

    var onSale = was > now;
    var prefix = empty ? box.getAttribute('data-fi-from-label') : onSale ? box.getAttribute('data-fi-sale-label') : '';
    var nodes = [];
    var current = el('span', 'fi-price__now' + (onSale ? ' fi-price__now--sale' : ''), (prefix ? prefix + ' ' : '') + money(now));
    current.setAttribute('data-fi-mod', '');
    nodes.push(current);
    if (onSale) {
      nodes.push(el('span', 'fi-price__was', (box.getAttribute('data-fi-was-label') || '') + ' ' + money(was)));
      var saveText = box.getAttribute('data-fi-save-label');
      if (saveText) {
        var saving = was - now;
        nodes.push(
          el('span', 'fi-price__save', saveText.split('[amount]').join(money(saving)).split('[percent]').join(String(Math.round((saving * 100) / was))))
        );
      }
    }
    box.textContent = '';
    append(box, nodes);
  }

  /* Same sums as the finance box in fi-pdp-part.liquid, for the price now chosen. */
  function paintFinance() {
    var box = $('[data-fi-finance]');
    if (!box) return;
    var total = unitPrice();
    if (box.fiSignature === total) return;
    box.fiSignature = total;

    var zopa = 0;
    String(box.getAttribute('data-fi-fin-tiers') || '').split(',').forEach(function (tier) {
      var parts = tier.trim().split(':');
      var term = parseInt(parts[0], 10) || 0;
      var min = Math.round(parseFloat(parts[1]) * 100);
      var max = Math.round(parseFloat(parts[2]) * 100);
      if (total >= min && total <= max && term > zopa) zopa = term;
    });

    var monthly = 0;
    if (total > 0) {
      if (box.hasAttribute('data-fi-fin-dividebuy')) {
        var months = parseInt(box.getAttribute('data-fi-fin-months'), 10) || 0;
        if (months > 0) monthly = Math.floor(total / months);
      } else {
        monthly = zopa > 0 ? Math.floor(total / zopa) : Math.floor((total + 2) / 3);
      }
    }
    var from = $('[data-fi-fin-from]', box);
    if (from) {
      from.hidden = !(monthly > 0);
      var amount = $('[data-fi-fin-from-amount]', from);
      if (amount) amount.textContent = money(monthly);
    }

    var pounds = total / 100;
    $$('[data-fi-fin-line]', box).forEach(function (line) {
      var key = line.getAttribute('data-key');
      var n = key === 'zopa' ? zopa : parseInt(line.getAttribute('data-n'), 10) || 0;
      var tpl = line.getAttribute('data-tpl') || '';
      var min = parseFloat(line.getAttribute('data-min')) || 0;
      var max = parseFloat(line.getAttribute('data-max')) || 0;
      var show = tpl !== '' && !(key === 'zopa' && zopa === 0);
      if (min > 0 && pounds < min) show = false;
      if (max > 0 && pounds > max) show = false;
      var text = tpl;
      if (n > 0 && total > 0) {
        var each = key === 'dividebuy' || key === 'zopa' ? Math.floor(total / n) : Math.floor((total + n - 1) / n);
        text = tpl.split('[n]').join(String(n)).split('[amount]').join(money(each));
      }
      line.textContent = text;
      line.hidden = !show;
    });
    $$('[data-fi-fin-chip="zopa"]', box).forEach(function (chip) {
      chip.hidden = zopa === 0;
    });

    var modal = $('[data-fi-finance-modal]');
    if (modal) modal.setAttribute('data-price', total);
  }

  /* The care-plan tier is priced from the sofa, which here is the set or the build. */
  function paintCarePlan() {
    var addons = $('[data-fi-addons]');
    if (!addons) return;
    var price = String(unitPrice());
    if (addons.getAttribute('data-fi-sofa-price') === price) return;
    addons.setAttribute('data-fi-sofa-price', price);
    if (window.FIPDP && typeof window.FIPDP.refreshCarePlanPreview === 'function') window.FIPDP.refreshCarePlanPreview();
  }

  /* Nothing chosen, or something chosen that is not in stock: neither button can buy it.
     The sticky bar's buttons follow from fi-pdp-v5.js syncBarPrice. */
  function paintButtons() {
    var can = ready();
    var form = mainForm();
    var submit = form && form.querySelector('[name="add"]');
    if (submit && submit.disabled === can) submit.disabled = !can;
    $$('[data-fi-proxy="buy-now"]').forEach(function (button) {
      if (button.disabled === can) button.disabled = !can;
    });
  }

  function restore() {
    if (!active()) return;
    paintPrice();
    paintButtons();
  }

  var pending = false;

  function paint() {
    pending = false;
    if (!active()) return;
    paintCards();
    paintBuilder();
    paintSummary();
    paintPrice();
    paintFinance();
    paintCarePlan();
    paintButtons();
    if (window.FIPDP && typeof window.FIPDP.refreshAddonPricing === 'function') window.FIPDP.refreshAddonPricing();
  }

  /* One paint per frame, however many taps and change events arrive inside it. */
  function schedule() {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(paint);
  }

  /* ---- Add to Basket: everything in one call ----
     The theme's form would add the sofa product itself. On a modular page its submit is
     taken here instead, in the capture phase so product-form.js never sees it, and the
     choice goes in with the ticked add-ons in a single /cart/add.js call. It ends as
     product-form.js does — the drawer is rendered from the response and the add is
     announced as the form's own — exactly as fi-pdp-bed.js does for beds. */
  function addTogether(form) {
    var host = form.closest('product-form');
    var button = form.querySelector('[type="submit"]');
    if (!button || button.getAttribute('aria-disabled') === 'true' || !ready()) return;
    var spinner = host && host.querySelector('.loading__spinner');
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var showError = function (message) {
      if (host && typeof host.handleErrorMessage === 'function') host.handleErrorMessage(message);
    };

    var items = lines(quantity());
    if (!items.length) return;
    var addons = window.FIPDP && typeof window.FIPDP.selectedAddons === 'function' ? window.FIPDP.selectedAddons() : [];
    addons.forEach(function (addon) {
      var item = { id: Number(addon.id), quantity: addon.quantity };
      if (addon.properties) item.properties = addon.properties;
      items.push(item);
    });

    showError();
    button.setAttribute('aria-disabled', 'true');
    button.classList.add('loading');
    if (spinner) spinner.classList.remove('hidden');

    var payload = { items: items };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      payload.sections = cart.getSectionsToRender().map(function (section) {
        return section.id;
      });
      payload.sections_url = window.location.pathname;
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
    }
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (result) {
        if (result.status) {
          if (typeof publish === 'function') {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: items[0].id,
              errors: result.errors || result.description,
              message: result.message
            });
          }
          showError(result.description || result.message);
          return;
        }
        if (!cart) {
          window.location = (window.routes && window.routes.cart_url) || root + 'cart';
          return;
        }
        /* A subscriber that throws must not keep the drawer from showing the sofa. */
        try {
          if (typeof publish === 'function') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: items[0].id, cartData: result });
          }
        } catch (e) {
          console.error(e);
        }
        cart.renderContents(result);
      })
      .catch(function (error) {
        console.error(error);
      })
      .finally(function () {
        button.classList.remove('loading');
        button.removeAttribute('aria-disabled');
        if (spinner) spinner.classList.add('hidden');
        if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
      });
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (form !== mainForm() || !active()) return;
      event.preventDefault();
      event.stopPropagation();
      addTogether(form);
    },
    true
  );

  /* ---- Interaction ---- */

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target.closest || !active()) return;

    var tab = target.closest('[data-fi-mod-mode]');
    if (tab) {
      setMode(tab.getAttribute('data-fi-mod-mode'));
      return;
    }

    var pick = target.closest('[data-fi-mod-select]');
    if (pick) {
      var card = pick.closest('[data-fi-mod-layout]');
      state.layoutId = card.getAttribute('data-product-id');
      schedule();
      return;
    }

    var step = target.closest('[data-fi-mod-step]');
    if (step) {
      var row = step.closest('[data-fi-mod-module]');
      var pid = row.getAttribute('data-product-id');
      if (step.getAttribute('data-fi-mod-step') === '1') {
        addPiece(pid);
      } else {
        removeOne(pid);
      }
      return;
    }

    var piece = target.closest('[data-fi-mod-piece]');
    if (piece) {
      var uid = Number(piece.getAttribute('data-fi-mod-piece'));
      state.selected = state.selected === uid ? null : uid;
      paintBuilder();
      var again = $('[data-fi-mod-piece="' + uid + '"]');
      if (again) again.focus();
      return;
    }

    if (target.closest('[data-fi-mod-remove]')) {
      removeSelected();
      return;
    }
    if (target.closest('[data-fi-mod-rotate]')) {
      rotateSelected();
      return;
    }
    if (target.closest('[data-fi-mod-undo]')) {
      undo();
      return;
    }
    if (target.closest('[data-fi-mod-flip]')) {
      flip();
      return;
    }
    if (target.closest('[data-fi-mod-clear]')) {
      clearPlan();
      return;
    }

    if (target.closest('[data-fi-mod-edit]')) {
      if (state.mode !== 'build') setMode('build');
      var plan = $('[data-fi-mod-plan]');
      if (plan) {
        plan.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
      }
      return;
    }

    /* A tap anywhere else lets go of the selected piece. */
    if (state.selected !== null && !target.closest('[data-fi-mod-pop]')) {
      state.selected = null;
      paintBuilder();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (!active() || !event.target.closest) return;

    /* Tabs: arrows move and activate, as a tablist should. */
    var tab = event.target.closest('[data-fi-mod-mode]');
    if (tab && /^(ArrowLeft|ArrowRight|Home|End)$/.test(event.key)) {
      var tabs = $$('[data-fi-mod-mode]');
      var index = tabs.indexOf(tab);
      var next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
      event.preventDefault();
      setMode(tabs[next].getAttribute('data-fi-mod-mode'));
      tabs[next].focus();
      return;
    }

    if (state.selected === null) return;
    if (event.key === 'Escape') {
      var uid = state.selected;
      state.selected = null;
      paintBuilder();
      var piece = $('[data-fi-mod-piece="' + uid + '"]');
      if (piece) piece.focus();
    } else if ((event.key === 'Delete' || event.key === 'Backspace') && event.target.closest('[data-fi-mod-piece]')) {
      event.preventDefault();
      removeSelected();
      var first = $('[data-fi-mod-piece]');
      if (first) first.focus();
    }
  });

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target.matches || !active()) return;

    if (target.matches('[data-fi-mod-footstool]')) {
      var linked = linkedStool();
      if (linked && state.mode === 'build') {
        if (target.checked && !count(linked)) {
          if (!addPiece(linked)) target.checked = false;
        }
        if (!target.checked && count(linked)) removeAll(linked);
      }
      schedule();
      return;
    }

    /* The sofa's colour: product-info.js writes the new variant into the form's id. */
    if (target.matches('product-info .product-variant-id, product-info [name="id"]')) {
      readOptions();
      resolveVariants();
      schedule();
      return;
    }

    if (target.matches('[data-fi-addon], [name="quantity"]')) schedule();
  });

  document.addEventListener('input', function (event) {
    if (event.target.matches && event.target.matches('[name="quantity"]') && active()) schedule();
  });

  /* Drag a module row onto the plan: the same as tapping its +. */
  document.addEventListener('dragstart', function (event) {
    var row = event.target.closest && event.target.closest('[data-fi-mod-module]');
    if (!row || !event.dataTransfer) return;
    event.dataTransfer.effectAllowed = 'copy';
    event.dataTransfer.setData('text/plain', row.getAttribute('data-product-id'));
  });

  document.addEventListener('dragover', function (event) {
    var plan = event.target.closest && event.target.closest('[data-fi-mod-plan]');
    if (!plan) return;
    event.preventDefault();
    plan.classList.add('is-dropping');
  });

  document.addEventListener('dragleave', function (event) {
    var plan = event.target.closest && event.target.closest('[data-fi-mod-plan]');
    if (plan && !plan.contains(event.relatedTarget)) plan.classList.remove('is-dropping');
  });

  document.addEventListener('drop', function (event) {
    var plan = event.target.closest && event.target.closest('[data-fi-mod-plan]');
    if (!plan || !event.dataTransfer) return;
    event.preventDefault();
    plan.classList.remove('is-dropping');
    var pid = event.dataTransfer.getData('text/plain');
    if (catalog[pid]) addPiece(pid);
  });

  /* ---- Start, and start again after the theme editor re-renders the section ---- */

  function active() {
    return cards().length > 0 || rows().length > 0;
  }

  function init() {
    state.plan = [];
    state.stools = [];
    state.flipped = false;
    state.selected = null;
    state.history = [];
    state.seeded = false;
    if (!active()) return;

    readOptions();
    readCatalog();
    resolveVariants();
    var current = $('[data-fi-mod-layout].is-active') || cards()[0];
    state.layoutId = current ? current.getAttribute('data-product-id') : null;
    var open = $('[data-fi-mod-panel]:not([hidden])');
    setMode(open ? open.getAttribute('data-fi-mod-panel') : 'set');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  /* Selecting the set or build block in the editor shows it, even when the other is open. */
  document.addEventListener('shopify:block:select', function (event) {
    var panel = event.target.closest && event.target.closest('[data-fi-mod-panel]');
    if (panel && active()) setMode(panel.getAttribute('data-fi-mod-panel'));
  });

  /* product-info.js re-renders the price and the buttons from the sofa's own variant
     after a colour change. The colour itself is picked up from the form's id (above);
     this puts the modular figures back once its pass is over. */
  (function watchVariantChange() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') {
      setTimeout(watchVariantChange, 300);
      return;
    }
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      if (!active()) return;
      readOptions(event && event.data && event.data.variant);
      resolveVariants();
      restore();
      schedule();
    });
  })();

  api.active = active;
  api.ownsAdd = function () {
    return active() && !!mainForm();
  };
  api.ready = ready;
  api.unitPrice = function () {
    return state.mode === 'build' && !pieces().length ? 0 : unitPrice();
  };
  api.unitCompare = unitCompare;
  api.lines = lines;
  api.restore = restore;
})();
